import { ComponentProps, FunctionComponent, ReactNode, useState } from 'react'
import { Form } from 'react-bootstrap'
import classnames from 'classnames'

import Icon from 'components/ui/icon'
import passwordInputCss from './passwordInput.module.scss'

type PasswordInputProps = Omit<ComponentProps<typeof Form.Control>, 'type' | 'onChange'> & {
  onChange?: React.ChangeEventHandler<HTMLInputElement>
  /** Rendered after the input (e.g. Form.Control.Feedback), keeping sibling selectors working. */
  children?: ReactNode
  /** Classes for the wrapper; use it (not className) to change the field width. */
  wrapperClassName?: string
}

/** Password field with a button to show/hide what was typed. */
const PasswordInput: FunctionComponent<PasswordInputProps> = ({
  children,
  className,
  wrapperClassName,
  size,
  ...props
}) => {
  const [visible, setVisible] = useState(false)

  return (
    <div
      className={classnames(
        passwordInputCss.wrap,
        size === 'lg' && passwordInputCss.lg,
        wrapperClassName
      )}
    >
      <Form.Control
        {...props}
        size={size}
        type={visible ? 'text' : 'password'}
        className={classnames(passwordInputCss.input, className)}
      />
      <button
        type="button"
        // Keeps keyboard navigation going straight between the form fields.
        tabIndex={-1}
        className={passwordInputCss.toggle}
        aria-label={visible ? 'Ocultar senha' : 'Mostrar senha'}
        onClick={() => setVisible(!visible)}
      >
        <Icon name={visible ? 'eyeOff' : 'eye'} size={18} />
      </button>
      {children}
    </div>
  )
}

export default PasswordInput
